// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2vhy7","location":"Header_location__1elSX"};